<!-- <div ng-switch="!!error"><div class="alert alert-danger" ng-switch-when="true"> {{error}} </div></div> -->
<div class="container">
  <div class="row">
    <div class="span9">
      <h1> Send report</h1>
    </div>
    <p class="lead">
      Send an update report message for an existing registered report. Generally this operation is performed on a schedule automatically as specified by the registered report.
      Only VENs with registered reports configured and NOT paused are able to perform this action.
    </p>
  </div>
  @if(isLoading) {
    <app-loader
      message="Loading...">
    </app-loader>
  } @else {
    <form name="requestForm" class="form-horizontal">
      <div class="form-group">
        <label for="venId"> Ven id (format: [ven_id] : [id]): </label>
        <select id="venId" class="form-control" name="ven.ven_id" type="select" (change)="setVens($event.target)" required >
          <option disabled selected value></option>
          @for(ven of vens; track ven) {
            <option [value]="ven.id">{{ven.ven_id}} : {{ven.id}}</option>
          }
        </select>
      </div>

      <div class="form-group">
        <label for="report_id"> Report Id (format: [id] : [granularity]): </label>
        <select id="report_id" class="form-control" name="id" type="select" (change)="registeredReport($event.target)" required >
          <option disabled selected value></option>
          @for(registered_report of registered_reports; track registered_report) {
            <option [value]="registered_report.id">{{registered_report.id}} : {{registered_report.granularity}}</option>
          }
        </select>
      </div>

      <button id="performAction" class="btn btn-primary" type="button" (click)="performAction()">Perform action</button>
    </form>
    <h3> Request Results</h3>
    <div class="container-fluid">
      <div class="row"> <label> Status: </label> {{status}}</div>
      <div class="row"> <label> Number of RIDs: </label> {{result.num_rids}} </div>
      <div class="row"> <label> Number of intervals expected: </label> {{result.expected}} </div>
      <div class="row"> <label> Number of intervals available: </label> {{result.available}} </div>
      <div class="row"> <label> Number of intervals missing: </label> {{result.missing}} </div>
      <div class="row"> <label> Number of intervals updated: </label> {{result.updated}} </div>
      <div class="row"> <label> Number of intervals sent successfully: </label> {{result.succeeded}} </div>
      <div class="row"> <label> Splunk query: </label>
        @if(venSelected && result.report_request?.report_id) {
          <label> "Sending registered report to VTN. ven_id={{venSelected.id}}, report_id={{result.report_request.report_id}}"  </label>
        }
      </div>
    </div>
  }
</div>
